import React from 'react';
import { Box } from '@mui/material';
import { ExceptionPeriod } from 'common/types';
import { validateExceptionPeriodDates } from './utils';

import ContainerBox from 'components/ContainerBox';
import SingleExceptionPeriod from './ExceptionPeriod';

interface Props {
	value: ExceptionPeriod[];
	onChange: (value: ExceptionPeriod[]) => void;
	locationId: string;
}
const ExceptionPeriods = (props: Props) => {
	const { value, onChange } = props;

	const updateExceptionPeriod = (updatedPeriod: ExceptionPeriod) => {
		onChange(value.map((period) => (period.id === updatedPeriod.id ? updatedPeriod : period)));
	};

	const removeExceptionPeriod = (id: string) => {
		onChange(value.filter((period) => period.id !== id));
	};

	return (
		<Box>
			{value.map((period, index) => (
				<ContainerBox key={`${period.startDate}_${period.endDate}`}>
					<SingleExceptionPeriod
						value={period}
						onChange={(data) => updateExceptionPeriod(data)}
						onDelete={() => removeExceptionPeriod(period.id)}
						isValid={validateExceptionPeriodDates(period, value.slice(0, index))}
					/>
				</ContainerBox>
			))}
		</Box>
	);
};

export default ExceptionPeriods;
